import { render, staticRenderFns } from "./reportingList.vue?vue&type=template&id=651c4646&scoped=true&"
import script from "./reportingList.vue?vue&type=script&lang=js&"
export * from "./reportingList.vue?vue&type=script&lang=js&"
import style0 from "./reportingList.vue?vue&type=style&index=0&id=651c4646&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651c4646",
  null
  
)

export default component.exports